import React from 'react';
import { Popover } from 'antd';
import { useTranslation } from 'react-i18next';

import { HelixConnectivityEnum, HelixDetailsMappingByConnectivityStatus } from './HelixConnectivityIcon.utils';

const HelixConnectivityIcon = ({
  helixConnectivityStatus,
  connectivity,
}: {
  helixConnectivityStatus: string;
  connectivity?: string;
}) => {
  const { t } = useTranslation();
  let status: string;

  switch (true) {
    case connectivity?.toLowerCase() === HelixConnectivityEnum.Connected?.toLowerCase():
      status = HelixConnectivityEnum.Connected;
      break;
    case !helixConnectivityStatus || helixConnectivityStatus == '':
      status = HelixConnectivityEnum.Null;
      break;
    default:
      if (connectivity?.toLowerCase() === HelixConnectivityEnum.NoState?.toLowerCase()) {
        status = helixConnectivityStatus;
      } else {
        status = `${connectivity || ''}${helixConnectivityStatus}`;
      }
  }
  const connectivityIcon = HelixDetailsMappingByConnectivityStatus[status];
  return <Popover content={t(connectivityIcon?.tooltipText)}>{connectivityIcon?.icon}</Popover>;
};

export default HelixConnectivityIcon;
